
export enum FilterKeys {
    CITY = 'city',
    FEEDBACK = 'feedbackRating',
    CATEGORIES = 'categories',
    RATE = 'rate',
    LANGUAGES = 'languages',
    SEACRCH_TERMS = 'searchTerms',
    MIN_RATE = 'minRate',
    MAX_RATE = 'maxRate'
}